export const INFORMATION_BANNER_PREFIX = "InformationBanner";

export const INFORMATION_BANNER_CLASSES = {
  txtContainer: `${INFORMATION_BANNER_PREFIX}-txtContainer`,
  text: `${INFORMATION_BANNER_PREFIX}-text`,
  link: `${INFORMATION_BANNER_PREFIX}-link`,
  closeButton: `${INFORMATION_BANNER_PREFIX}-closeButton`,
};
